<template>
    <div class="bot">
        <div class="left">
            <van-icon name="arrow-left" class="bot_arr" />
            <van-icon name="arrow" class="bot_arr" />
            <van-icon name="replay" />
        </div>
        <div class="right">
            <van-icon name="share" />
            <span>返回遊戲</span>
        </div>
    </div>
</template>

<script>
export default {
    name:'HomeBot',
    data () {
        return {
        }
    }
}
</script>

<style lang="stylus" scoped>
@media all and (orientation : landscape)
    .van-icon
        display block
        color #d2a852
        padding-right .03rem
        vertical-align middle
        font-size 0.475rem
    .bot
        display flex
        width 100%
        padding 1% 0
        text-align center
        position fixed
        z-index 1
        bottom 0
        left 0
        background #333
        .left
            display flex
            flex .8
            text-align left
            padding-left 3%
            .bot_arr
                flex .3
                vertical-align middle
        .right
            flex 1
            text-align right
            padding-right 16%
            display flex
            position relative
            span
                display inline-block
                color #d2a852
                position absolute
                right 10%
                top 30%
            .van-icon-share
                flex .96
@media all and (orientation : portrait)
    .van-icon
        display block
        color #d2a852
        padding-right .03rem
        vertical-align middle
        font-size 0.475rem
    .bot
        display flex
        width 100%
        padding 1% 0
        text-align center
        position fixed
        z-index 1
        bottom 0
        left 0
        background #333
        .left
            display flex
            flex 1
            text-align left
            padding-top: 1%
            padding-left 3%
            .bot_arr
                flex .45
                vertical-align middle
        .right
            flex 1
            text-align right
            padding-right 16%
            display flex
            position relative
            span
                display inline-block
                color #d2a852
                position absolute
                right 10%
                top 30%
            .van-icon-share
                flex .8
                padding-top: 2%
</style>